import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useCreateSolutionMutation } from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faS, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { categories, industryTypes } from "../helpers/categories";
import Input from "../Builder/nodes/Logic/Inputs/Input";

export default function CreateSolutionForm({ solution, setSolution }) {
  const [createSolution] = useCreateSolutionMutation();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const saveSolution = () => {
    setLoading(true);
    createSolution(solution).then((res) => {
      if ("data" in res) {
        setSolution(res.data);
        toast.success("Solution saved successfully");
      }
      if ("error" in res && res.error?.data?.errors) {
        setErrors(res.error.data.errors);
      }
      setTimeout(() => {
        setLoading(false);
      }, 700);
    });
  };

  return (
    <>
      <div className="p-3 d-flex gap-4 flex-wrap">
        <div className="flex-grow-1">
          <Form.Label className="fw-bold">Label: </Form.Label>
          <Form.Control
            type="text"
            placeholder="Solution Label"
            value={solution.Label}
            onChange={(e) => {
              setSolution({ ...solution, Label: e.target.value });
              setErrors({ ...errors, "Solution.Label": null });
            }}
            className="mb-3"
          />
          {errors["Solution.Label"] && (
            <div className="alert alert-danger p-1 mb-2">
              {errors["Solution.Label"]}
            </div>
          )}

          <Form.Label className="fw-bold">Description: </Form.Label>
          <Form.Control
            as="textarea"
            value={solution.Description}
            onChange={(e) =>
              setSolution({ ...solution, Description: e.target.value })
            }
            className="mb-3"
          />

          <Form.Label className="fw-bold">Reference: </Form.Label>
          <Form.Control
            type="text"
            placeholder="Solution Reference"
            value={solution.Reference}
            onChange={(e) =>
              setSolution({ ...solution, Reference: e.target.value })
            }
            className="mb-3"
          />

          <Form.Label className="fw-bold">Status: </Form.Label>
          <Form.Select
            className="mb-3"
            aria-label="status-select"
            onChange={(e) => {
              setSolution({ ...solution, Status: e.target.value });
            }}
            value={solution.Status}
          >
            <option value="public">public</option>
            <option value="private">private</option>
            <option value="draft">draft</option>
          </Form.Select>

          <Form.Label className="fw-bold">Kind: </Form.Label>
          <Form.Select
            className="mb-3"
            aria-label="kind-select"
            onChange={(e) => {
              setSolution({ ...solution, Kind: e.target.value });
            }}
            value={solution.Kind}
            disabled={!!solution.Uuid}
          >
            <option value="standard">Standard</option>
            <option value="events">Events</option>
          </Form.Select>
        </div>
        <div className="flex-grow-1 gap-2 d-flex flex-column">
          <Form.Label className="fw-bold">Version: </Form.Label>
          <Form.Control
            type="text"
            placeholder="Solution Version"
            value={solution.Version}
            onChange={(e) => {
              setSolution({ ...solution, Version: e.target.value });
              setErrors({ ...errors, "Solution.Version": null });
            }}
            className="mb-3"
          />
          {errors["Solution.Version"] && (
            <div className="alert alert-danger p-1 mb-2">
              {errors["Solution.Version"]}
            </div>
          )}
          <div className="mb-2">
            <div className="d-flex justify-content-between">
              <Form.Label className="fw-bold">Industry: </Form.Label>
              {/* <HelpButton helpKey={} /> */}
            </div>
            <div className=" bg-white rounded-3">
              <Input
                inputType="select"
                isMulti
                isValidNewOption={(o) => o}
                value={solution?.TagsMap?.industry || []}
                onChange={(values) =>
                  setSolution((prev) => ({
                    ...prev,
                    TagsMap: {
                      ...(prev.TagsMap || { category: [], folder: [] }),
                      industry: values,
                    },
                  }))
                }
                options={[
                  {
                    value: "",
                    label: `Default from product settings`,
                  },
                  ...industryTypes.map((c) => ({
                    value: c,
                    label: c,
                  })),
                ]}
              />
            </div>
          </div>
          <div className="mb-2">
            <div className="d-flex justify-content-between">
              <Form.Label className="fw-bold">Category: </Form.Label>
            </div>{" "}
            <div className="bg-white rounded-3">
              <Input
                inputType="select"
                isMulti
                isValidNewOption={(o) => o}
                value={solution?.TagsMap?.category || []}
                onChange={(values) =>
                  setSolution((prev) => ({
                    ...prev,
                    TagsMap: {
                      ...(prev.TagsMap || { industry: [], folder: [] }),
                      category: values,
                    },
                  }))
                }
                options={[
                  {
                    value: "",
                    label: `Default from product settings`,
                  },
                  ...categories.map((c) => ({
                    value: c,
                    label: c,
                  })),
                ]}
              />
            </div>
          </div>
          <div className="mb-2">
            <Form.Label className="fw-bold">Business Use-Case: </Form.Label>

            <Form.Select
              aria-label="deployed-select"
              onChange={(e) => {
                setFilters({
                  ...filters,
                  deployed: e.target.value,
                  offset: 0,
                });
              }}
            >
              <option value="yes">yes</option>
              <option value="no">no</option>
              <option value="">all</option>
            </Form.Select>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <Button
          className="mb-3 bg-colored fw-bold"
          onClick={saveSolution}
          disabled={loading}
        >
          {solution.Uuid ? "Save Changes" : "Create Solution"}
          {loading && (
            <FontAwesomeIcon icon={faSpinner} spin className="ms-2" />
          )}
        </Button>
      </div>
    </>
  );
}
